<template>

  <div class="docuform-list-item">

    <v-layout justify-space-between>
      <div class="docuform-title"
           data-qa="docuform-title">
        {{docuform.title}}
      </div>
      <div class="docuform-status">
        <VcIcon :color="statusInfo.color">{{statusInfo.icon}}</VcIcon>
        <span class="docuform-status__text" data-qa="docuform-status" :style="{color: statusInfo.color}">{{$t(statusInfo.mobileLabel)}}</span>
      </div>
    </v-layout>

    <v-layout justify-space-between>
      <DisplayName :matter="docuform.matter" :contact="docuform.contact"/>
      <div class="docuform-date">{{docuform.updated_at | time_today_or_date}}</div>
    </v-layout>

  </div>

</template>

<script>
import {DisplayName} from "@/modules/common/components";
import {statuses} from "@/modules/docuform/constants";
import getStatus from "@/modules/docuform/services/statusService";

export default {
  name: "DocuformListItemMobile",
  components: {DisplayName},
  props: {
    docuform: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      statuses: statuses
    }
  },
  computed: {
    statusInfo() {
      return getStatus(this.docuform);
    }
  }
}
</script>

<style lang="scss" scoped>
@import "@/assets/scss/abstract/_variables.scss";
@import "@/assets/scss/abstract/_mixins.scss";

.docuform-list-item {
  width: 100%;

  .docuform-title {
    font-size: 15px;
    font-weight: 500;
    width: 65%;
    @include ellipsis;
  }

  .docuform-status {
    position: relative;
    top: -2px;
    @include ellipsis;

    .v-icon {
      font-size: 16px;
      margin-inline-end: 6px;
    }

    &__text {
      font-size: 12px;
      font-weight: 600;
      text-transform: uppercase;
    }
  }

  .display-name {
    width: 75%;
    @include ellipsis;
  }

  .docuform-date {
    font-size: 13px;
    color: $grey-color-6;
    position: relative;
    top: 2px;
    line-height: 20px;
    @include ellipsis;
  }
}
</style>
